const state = {
  isCollapse: false
}
const mutations = {
  SET_IS_COLLAPSE: (state, isCollapse) => {
    console.log('isCollapse = ', isCollapse)
    state.isCollapse = isCollapse
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js